import React, { ReactElement, FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import ProgressCircle from '@sport1/react-elements/ProgressCircle'
import withTheme from '@sport1/react-elements/withTheme'
import BasicText from '../../Theme/Fonts/BasicText'
import { TestID } from '../../utils/PropTypesDefinitions'
import ThemeInterface from '../../themes/ThemeInterface'
import lightTheme from '../../themes/LightTheme'

type Props = {
    seconds: number
    onFinish: () => void
    theme?: ThemeInterface
} & TestID

const RevolverPlayCountdownLandscape: FunctionComponent<Props> = ({
    onFinish,
    testID,
    seconds,
    theme = lightTheme,
}): ReactElement => (
    <Grid noExpand horizontal centerVertical testID={testID}>
        <BasicText fontSize="FS18" lineHeight="LH24" color="WHITE">
            Nächstes Video in
        </BasicText>
        <Grid noExpand position="relative" marginLeft={4}>
            <ProgressCircle
                backgroundColor={theme.colors.pearl}
                fillColor={theme.colors['keshi-3']}
                size={70}
                strokeWidth={4}
                animationDuration={5000}
                onAnimationEnd={onFinish}
            >
                <BasicText fontSize="FS20" lineHeight="LH30" color="WHITE" bold>
                    {`${seconds}`}
                </BasicText>
            </ProgressCircle>
        </Grid>
    </Grid>
)

export default withTheme(RevolverPlayCountdownLandscape) as FunctionComponent<Props>
